import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import SourceRepository from '@/services/repository/SourceRepository';
import VueUtilities from '@/services/VueUtilities';
import { DEFAULT_PAUSE_NOTIFICATION_TIME, PredefinedTextLogger } from '@/entities/models/Annotation';
import AppConfig from '@/configLoader';
var sourceRepository;
let ChangeLoggerModal = class ChangeLoggerModal extends Vue {
    constructor() {
        super(...arguments);
        this.PredefinedTextLogger = PredefinedTextLogger;
        this.selectedLogger = null;
        this.createAssignAnnotation = true;
        this.createUnassignAnnotation = true;
        this.customAssignAnnotationText = '';
        this.customUnassignAnnotationText = '';
        this.predefinedAssignedAnnotation = null;
        this.predefinedUnassignedAnnotation = null;
        this.pauseNotifications = false;
        this.notificationPauseTime = DEFAULT_PAUSE_NOTIFICATION_TIME;
    }
    created() {
        sourceRepository = new SourceRepository(this);
        this.predefinedAssignedAnnotation = this.modalIsReassigning
            ? PredefinedTextLogger.REASSIGN
            : PredefinedTextLogger.ASSIGN;
        this.predefinedUnassignedAnnotation = PredefinedTextLogger.UNASSIGN;
    }
    /**
     * Check config if feature is On.
     */
    get annotateLogerStateChangeIsTurnedOn() {
        return AppConfig.getConfig().features.annotate_logger_state_change == true;
    }
    get annotationAssignTexts() {
        return Object.values(PredefinedTextLogger).filter((x) => x == PredefinedTextLogger.OWN ||
            x == (this.modalIsReassigning ? PredefinedTextLogger.REASSIGN : PredefinedTextLogger.ASSIGN));
    }
    get annotationUnassignTexts() {
        return Object.values(PredefinedTextLogger).filter((x) => x == PredefinedTextLogger.OWN || x == PredefinedTextLogger.UNASSIGN);
    }
    get availableCompanyLoggers() {
        return this.companyLoggers.filter((x) => x.active === true);
    }
    resultRetrieved() {
        this.$emit('modalClosed');
    }
    replace() {
        this.$validator.validateAll().then(async (result) => {
            if (result) {
                let self = this;
                this.$buefy.dialog.confirm({
                    title: this.modalIsReassigning == true
                        ? `${this.$t('component.logger.change_modal.confirmReplaceDialog.title')}`
                        : `${this.$t('component.logger.change_modal.confirmReplaceDialog.title_assign')}`,
                    message: this.selectedLogger.source.id ? this.$t('component.logger.change_modal.confirmReplaceDialog.message', {
                        name1: this.source.logger ? this.source.logger.serialNumber : '-',
                        name2: this.selectedLogger.serialNumber
                    }) : this.$t('component.logger.change_modal.confirmReplaceDialog.message_only_assign', {
                        name1: this.selectedLogger.serialNumber,
                        sourceName: this.source.name
                    }),
                    confirmText: `${this.$t('component.logger.change_modal.confirmReplaceDialog.confirm')}`,
                    cancelText: `${this.$t('component.logger.change_modal.confirmReplaceDialog.deny')}`,
                    type: 'is-primary',
                    hasIcon: true,
                    onConfirm: () => {
                        this.saveChanges();
                    },
                    onCancel: () => { }
                });
            }
        });
    }
    async saveChanges() {
        let assignmentData = {
            CompanyLoggerId: this.selectedLogger.companyLoggerId,
            PauseNotificationsFor: this.pauseNotifications ? this.notificationPauseTime : 0,
            UnassignAnnotation: this.createUnassignAnnotation && this.selectedLogger?.source?.id
                ? this.predefinedUnassignedAnnotation == PredefinedTextLogger.OWN
                    ? this.customUnassignAnnotationText
                    : this.$t(`component.report.create_annotation.predefined.${this.predefinedUnassignedAnnotation}`).toString()
                : '',
            AssignAnnotation: this.createAssignAnnotation
                ? this.predefinedAssignedAnnotation == PredefinedTextLogger.OWN
                    ? this.customAssignAnnotationText
                    : this.$t(`component.report.create_annotation.predefined.${this.predefinedAssignedAnnotation}`).toString()
                : ''
        };
        let updatedSource = await sourceRepository.assignLogger(this.source.id, assignmentData);
        if (updatedSource.logger.companyLoggerId == this.selectedLogger.companyLoggerId) {
            VueUtilities.openSuccessToast(this, this.$t('component.logger.change_modal.msg.success'));
            this.resultRetrieved();
            this.$emit('reloadSource');
        }
        else {
            VueUtilities.openErrorToast(this, this.$t('component.logger.change_modal.msg.failure'));
        }
    }
};
__decorate([
    Prop({ type: Object })
], ChangeLoggerModal.prototype, "source", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ChangeLoggerModal.prototype, "modalIsReassigning", void 0);
__decorate([
    Prop({ type: Boolean })
], ChangeLoggerModal.prototype, "annotateLogerStateChange", void 0);
__decorate([
    Prop({ type: Array })
], ChangeLoggerModal.prototype, "companyLoggers", void 0);
ChangeLoggerModal = __decorate([
    Component({ components: {} })
], ChangeLoggerModal);
export default ChangeLoggerModal;
